import React from "react";
import { Card, Row, Col } from "react-bootstrap";

const ContactPage = () => {
  return (
    <section className="p-5 bg-light">
      <h3 className="text-center mb-4">Contact Us</h3>
      <Row className="justify-content-center">
        <Col md={6}>
          <Card className="shadow-sm p-4">
            <Card.Body>
              <p>
                <strong>📍 Address:</strong>
                <br />
                3-111/4, Satya Surya Complex, Venkat Nagar, Kakinada, AP
              </p>
              <p>
                <strong>📞 Phone:</strong>{" "}
                <a href="tel:+919121943442">+91 9121943442</a>
              </p>
              <p>
                <strong>📧 Email:</strong>{" "}
                <a href="mailto:indianodysseyofficial@gmail.com">
                  indianodysseyofficial@gmail.com
                </a>
              </p>
              <p>
                <strong>📸 Instagram:</strong>{" "}
                <a
                  href="https://www.instagram.com/indianodyssey.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @indianodyssey.in
                </a>
              </p>
              <p>
                <strong>🔗 Google Business:</strong>{" "}
                <a
                  href="https://www.google.com/search?q=Indian+Odyssey+Kakinada"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Google
                </a>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </section>
  );
};

export default ContactPage;
